import STWWHomePage from './STWWHomePage';

export default STWWHomePage;
